<div class="dedicate-preinvoice samim" [class.full]="preinvoice && !done && pdfState != 'failed'">
    <ng-container *ngIf="preinvoice && !done">
        <div *ngIf="pdfState == 'loading'" class="loading"><i class="fa fa-spinner fa-spin fa-3x"></i></div>
        <div #pages class="pages" [hidden]="pdfState == 'failed'"></div>
        <div *ngIf="pdfState == 'failed'" class="panel">
            <h5>{{ 'DEDICATE_PREINVOICE' | translate }}</h5>
            <div class="hint">{{ 'DEDICATE_PREINVOICE_HINT' | translate }}</div>
            <div class="head">
                <span>{{ preinvoice.account_name }}</span>
                <span>{{ 'DEDICATE_PREINVOICE_NO' | translate }}: {{ preinvoice.no }}</span>
                <span>{{ 'DEDICATE_PREINVOICE_DATE' | translate }}: {{ preinvoice.date }}</span>
            </div>
            <div class="lines">
                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>{{ 'DEDICATE_PREINVOICE_ITEM' | translate }}</th>
                            <th>{{ 'DEDICATE_PREINVOICE_QUANTITY' | translate }}</th>
                            <th>{{ 'DEDICATE_PREINVOICE_PRICE' | translate }}</th>
                            <th>{{ 'DEDICATE_PREINVOICE_TOTAL' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let line of preinvoice.lines">
                            <td>{{ line.name_fa }}</td>
                            <td>{{ line.quantity | number:'1.0-0' }} {{ line.unit }}</td>
                            <td>{{ line.price | number:'1.0-0' }}</td>
                            <td>{{ line.total | number:'1.0-0' }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3">{{ 'DEDICATE_PREINVOICE_TOTAL' | translate }}</td>
                            <td>{{ preinvoice.total | number:'1.0-0' }}</td>
                        </tr>
                        <tr>
                            <td colspan="3">{{ 'DEDICATE_PREINVOICE_VAT' | translate }}</td>
                            <td>{{ preinvoice.vat | number:'1.0-0' }}</td>
                        </tr>
                        <tr class="payable">
                            <td colspan="3">{{ 'DEDICATE_PREINVOICE_PAYABLE' | translate }}</td>
                            <td>{{ preinvoice.payable | number:'1.0-0' }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="hint">{{ 'DEDICATE_PREINVOICE_RIAL' | translate }}</div>
        </div>
        <div *ngIf="error && !answerModal" class="toast-message message failed">{{ error }}</div>
        <div class="fabs">
            <button class="fab btn btn-success" [disabled]="loading" (click)="openAnswer(approve)"
                [title]="'DEDICATE_PREINVOICE_APPROVE' | translate" [attr.aria-label]="'DEDICATE_PREINVOICE_APPROVE' | translate">
                <i class="fa fa-check"></i>
            </button>
            <button class="fab btn btn-danger" [disabled]="loading" (click)="openAnswer(reject)"
                [title]="'DEDICATE_PREINVOICE_REJECT' | translate" [attr.aria-label]="'DEDICATE_PREINVOICE_REJECT' | translate">
                <i class="fa fa-times"></i>
            </button>
            <button class="fab btn btn-light" (click)="openPdf()"
                [title]="'DEDICATE_PREINVOICE_PDF' | translate" [attr.aria-label]="'DEDICATE_PREINVOICE_PDF' | translate">
                <i class="fa fa-download"></i>
            </button>
        </div>
    </ng-container>
    <div *ngIf="!preinvoice || done" class="panel">
        <h5>{{ 'DEDICATE_PREINVOICE' | translate }}</h5>
        <div *ngIf="ready && !preinvoice && !error" class="message failed">
            {{ 'DEDICATE_PREINVOICE_INVALID' | translate }}
        </div>
        <div *ngIf="done" class="message done">{{ 'DEDICATE_PREINVOICE_' + done | translate }}</div>
        <div *ngIf="!preinvoice && error" class="message failed">{{ error }}</div>
    </div>
</div>

<ng-template #reject let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'DEDICATE_PREINVOICE_REJECT' | translate }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <textarea class="form-control" rows="4" maxlength="500" [(ngModel)]="reason"
            [placeholder]="('DEDICATE_PREINVOICE_REASON' | translate) + ' *'"></textarea>
        <div *ngIf="error" class="message failed">{{ error }}</div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-secondary" [disabled]="loading" (click)="modal.dismiss()">
            {{ 'CANCEL' | translate }}
        </button>
        <button class="btn btn-danger" [disabled]="loading" (click)="answer(false)">
            {{ 'DEDICATE_PREINVOICE_REJECT' | translate }}
        </button>
    </div>
</ng-template>

<ng-template #approve let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'DEDICATE_PREINVOICE_APPROVE' | translate }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        {{ 'DEDICATE_PREINVOICE_APPROVE_CONFIRM' | translate }}
        <div *ngIf="error" class="message failed">{{ error }}</div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-secondary" [disabled]="loading" (click)="modal.dismiss()">
            {{ 'CANCEL' | translate }}
        </button>
        <button class="btn btn-success" [disabled]="loading" (click)="answer(true)">
            {{ 'DEDICATE_PREINVOICE_APPROVE' | translate }}
        </button>
    </div>
</ng-template>
